import LabeledSelect from "./LabeledSelect";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {DangerButton} from "../CustomButton";
import {loadWeeklyBrands} from "../../redux/slices/dynamicElementsSlice";
import isEmpty from "lodash/isEmpty";

const BrandWeekSelect = ({label, value, onChange, emptyMsg, isBrandDay, extData,...props}) => {

  const {loading, data, error, init} = useSelector((state) => state.dynamicElements.weeklyBrands);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(loadWeeklyBrands());
  }, [dispatch, data, error]);

  useEffect(() => {
    if (extData && !value &&  onChange && !isEmpty(data)){
        onChange(data.find((d) => d.id.toString() === extData))
    }
  }, [extData, data]);



  const retry = () => {
    dispatch(loadWeeklyBrands());
  };

  return (

    error ?
      <div className="flex items-center justify-between border-gray-300 border-solid border px-2 rounded">
        <div className="text-error-100 ">{error}</div>
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div> :
      <LabeledSelect label={label} value={value} loading={loading} getOptionLabel={(option) => option.name}
                     getOptionValue={(option) => option.id}
                     options={data}
                     onChange={onChange} emptyMsg={emptyMsg} {...props}/>


  );


};


export default React.memo(BrandWeekSelect);
